import EmailIcon from "@mui/icons-material/MailOutline";
import React from "react";

// Returns a `footerItem` descriptor compatible with CommonDropdown rather than
// a JSX node — this keeps CommonDropdown ignorant of feature-specific JSX
// while letting the report dropdown opt in with one line.
export const buildScheduleReportFooterItem = (onClick, label) => ({
	label: label ?? "Schedule an email report...",
	icon: <EmailIcon fontSize="small" />,
	onClick,
});
